import { 
    MessageResponseDto, 
    GetTerminationTypeDto, 
    CreateTerminationTypeDto, 
    EditTerminationTypeDto,
    UtilTerminationTypeControllerGet200Response,
    UtilityTerminationTypeApiFp,
    DeleteTerminationTypeDto,
} from "@api/api";
import { apiConfig } from "@core/query/config.query";
import { QueryKey } from "@core/query/query-key.enum";

export type GetResponseTerminationTypeModel = UtilTerminationTypeControllerGet200Response;
export type GetTerminationTypeModel = GetTerminationTypeDto;
export type MutateResponseTerminationTypeModel = MessageResponseDto;
export type CreateTerminationTypeModel = CreateTerminationTypeDto;
export type UpdateTerminationTypeModel = EditTerminationTypeDto;
export type DeleteTerminationTypeModel = DeleteTerminationTypeDto;

export const apiTerminationTypeFp =  UtilityTerminationTypeApiFp(apiConfig);
export const getTerminationTypeController = apiTerminationTypeFp.utilTerminationTypeControllerGet;
export const createTerminationTypeController = apiTerminationTypeFp.utilTerminationTypeControllerCreate;
export const updateTerminationTypeController = apiTerminationTypeFp.utilTerminationTypeControllerEdit;
export const deleteTerminationTypeController = apiTerminationTypeFp.utilTerminationTypeControllerDelete;

export const QueryKeyTerminationType = QueryKey.TerminationType;